import React from 'react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../../config';

export default function DashboardSupport() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Support</h1>
      <div className="glass rounded-xl p-6 max-w-lg">
        <p className="text-white/70">
          Email us at{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[#00d4ff]">{SUPPORT_EMAIL}</a>{' '}
          and we'll get back to you within 1–2 business days.
        </p>
        <Link to="/support" className="inline-block mt-4 text-sm text-white/50 hover:text-white">
          View full support page →
        </Link>
      </div>
    </div>
  );
}
